/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AddressModel { 
    id: number;
    clientId: number;
    address: string;
    admDiv?: string;
    cityId: number;
    entrance?: string;
    floor?: string;
    flat?: string;
    alias?: string;
    latitude?: number;
    longitude?: number;
    lastUsageDate: string;
    note?: string;
}

